<template>
  <v-container grid-list-md>
    <!-- Google Map Widget -->
    <v-card elevation="0" outlined>
      <v-toolbar color="blue darken-3" dark elevation="0">
        <v-toolbar-title>Add a Site for Inspection</v-toolbar-title>
      </v-toolbar>
      <div class="pa-1">
        <v-layout>
          <v-flex xs12>
            <v-form ref="form" v-model="valid" lazy-validation class="pa-5">
            <v-text-field
                    v-model="addressLine1"
                    label="Address Line 1"
                    id="address"
                    :rules="addressLine1Rules"
                    :counter="100"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="city"
                    label="City or Suburb"
                    :rules="cityRules"
                    :counter="100"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="postcode"
                    label="Postcode"
                    :rules="postcodeRules"
                    :counter="4"
                    :mask="mask"
                    required
            ></v-text-field>
            <div class="hint pb-5">
              Only Queensland postcodes are currently accepted. PO Boxes are
              not allowed.
            </div>
            <!--<label >
              <gmap-autocomplete
                id="address"
                style="width: 80%"
                class="pa-2"
                @place_changed="setPlace"
                :options="{ componentRestrictions: { country: 'au' } }"
              ></gmap-autocomplete>
              <v-btn @click="addSite" rounded color="primary" dark id="click" >Add</v-btn>
            </label>-->
            <v-btn @click="addSite" rounded color="primary" id="click" :disabled="!valid" >Add</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
        <br />
      </div>
      <br />
      <!--<gmap-map ref="mapRef" :center="center" :zoom="5" style="width:100%;  height: 400px;">
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          @click="center = m.position"
          :icon="{ url: require('../assets/blue-dot.png') }"
        ></gmap-marker>
      </gmap-map>-->
    </v-card>
    <v-card class="mt-5" elevation="0" outlined>
      <v-toolbar color="blue darken-3" dark elevation="0" id="list">
        <v-toolbar-title> Submit your Sites for Inspection</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!-- OUTER LIST FOR SITES -->

      <v-layout row fill-height justify-center align-center v-if="alert.loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-layout>
      <template  >
        <div v-for="(item) in items" :key="item" >
        <Site :site="item"></Site>
        </div>
      </template>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar v-model="alert.message" top left :timeout="timeout">
      {{alert.type}}
    </v-snackbar>



    <v-tour name="myTour" :steps="steps"></v-tour>

  </v-container>
</template>


<style>
  .v-step{
    background-color: rgba(117, 117, 117, 0.5) !important;
  }
  .v-step .v-step__arrow{
    border-bottom-color: rgba(117, 117, 117, 0.5) !important;

  }
  .hint {
    font-size: 15px;
    font-weight: 500;
  }
</style>

<script>
import axios from "axios";
import jwt_decode from "jwt-decode";
import { router } from "../router";
import { config } from "../config/config";
import { mapState } from "vuex";
import Site from "./Site.vue";
import { gmapApi } from 'vue2-google-maps'
import { checkLogin } from '../helpers/check'

export default {
  name: "Sites",
  components: {
    Site
  },
  data() {
    return {
      timeout: 6000,
      center: { lat: -19.258965, lng: 146.816956 },
      currentPlace: null,
      addressLine1: "",
      city: "",
      postcode: "",
      valid: false,
      addressLine1Rules: [
          v => !!v || "Address Line 1 is required",
          v =>
              (v && v.length <= 100) ||
              "Address Line 1 must be less than 100 characters"
      ],
      cityRules: [
          v => !!v || "City or Suburb is required",
          v =>
              (v && v.length <= 100) ||
              "City or Suburb must be less than 100 characters"
      ],
      postcodeRules: [
          v => !!v || "Postcode is required",
          v => (v && v.length <= 4) || "Postcode must be less than 4 characters",
          v =>
              (v && parseInt(v) >= 4000 && parseInt(v) <= 4999) ||
              "Only Queensland postcodes are currently accepted. PO Boxes are not allowed."
      ],
      steps: [
        {
          target: '#address',
          content: `<strong> Enter Your site address and press add</strong>!`
        },
        {
          target: '#click',
          content: 'Click here to add site. You can change or delete it later.'
        },
        {
          target: '#list',
          content: 'Your site will appear here! You can submit it for inspection.',
          params: {
            placement: 'top'
          }
        }
      ]
    };
  },

  computed: {
    google: gmapApi,
    ...mapState("sites", {
      items: state => state.sites,
      markers(state) {
        let markers = [];
        state.sites.forEach(function(loc) {
          if(loc.LATITUDE && loc.LONGITUDE) {
            const marker = {
              lat: parseFloat(loc.LATITUDE),
              lng: parseFloat(loc.LONGITUDE)
            };
            markers.push({position: marker});
          }
        });
        return markers;
      },
      bounds(state) {
        let bounds = new google.maps.LatLngBounds();
        state.sites.forEach(function(loc) {
          if(loc.LATITUDE && loc.LONGITUDE) {
            const marker = {
              lat: parseFloat(loc.LATITUDE),
              lng: parseFloat(loc.LONGITUDE)
            };
            bounds.extend(marker);
          }
        });
        return bounds;
      }
    }),
    alert () {
      return this.$store.state.alert
    }
  },
  mounted() {
    if (checkLogin()) {
      router.push("/login");
    }
    else {

      this.$store.dispatch("sites/getSites").then(
        () => {
          if (this.items.length > 0) {
            this.$refs.mapRef.$mapPromise.then((map) => {
              this.fitMap(map);
            })
          }
        },
        error => {
        }
      );
      this.$tours['myTour'].start();
    }
  },
  methods: {
    fitMap(map){
      map.fitBounds(this.bounds);
      google.maps.event.addListenerOnce(map, 'bounds_changed',
        function () {
          this.setZoom(Math.min(15, this.getZoom()));
        });
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    addSite() {
       if (this.$refs.form.validate()) {
        const { address, latitude, longitude } = {
          address: this.addressLine1 + ", " + this.city + ", " + "QLD" +
          " " + this.postcode + ", Australia", //.formatted_address,
          latitude: null, //this.currentPlace.geometry.location.lat().toFixed(6),
          longitude: null, //this.currentPlace.geometry.location.lng().toFixed(6)
        };
        this.$store.dispatch("sites/add", {
          address: address,
          latitude: latitude,
          longitude: longitude
        }).then(
          () => {
            if (this.items.length > 0) {
              this.$refs.mapRef.$mapPromise.then((map) => {
                this.fitMap(map);
              })
            }
          },
          error => {
          }
        );
      }
    },
    checkLoggedIn() {},
  }
};
</script>
